import { TStoreState } from 'redux/types';

export const selectEmProductFileUploadsState = (state: TStoreState) => state.emProductFileUploads;
export const selectUploadedFiles = (state: TStoreState) => state.emProductFileUploads.uploadedFiles;
export const selectUploadedFilesLoading = (state: TStoreState) =>
	state.emProductFileUploads.uploadedFilesLoading;
export const selectUploadFileLoading = (state: TStoreState) =>
	state.emProductFileUploads.uploadFileLoading;
export const selectDownloadLoading = (state: TStoreState) =>
	state.emProductFileUploads.downloadLoading;
